<div class="history-dropdown" data-testid="allo-history">
  @if (isEmpty()) {
    <span class="history-empty" data-testid="allo-history-empty">
      {{ 'GNR_NO_CHATS' | translate }}
    </span>
  } @else {
    @if (pinnedChats().length) {
      <h3 class="history-section-title" data-testid="allo-history-pinned-title">
        {{ 'GNR_PINNED' | translate }}
      </h3>
      <div class="history-list" data-testid="allo-history-pinned">
        @for (item of pinnedChats(); track item.id) {
          <ng-container
            [ngTemplateOutlet]="historyRow"
            [ngTemplateOutletContext]="{ $implicit: item }" />
        }
      </div>
    }

    @if (visibleRecents().length) {
      <h3
        class="history-section-title"
        data-testid="allo-history-recents-title">
        {{ 'GNR_RECENTS' | translate }}
      </h3>
      <div class="history-list" data-testid="allo-history-recents">
        @for (item of visibleRecents(); track item.id) {
          <ng-container
            [ngTemplateOutlet]="historyRow"
            [ngTemplateOutletContext]="{ $implicit: item }" />
        }
      </div>
    }

    @if (hasMore()) {
      <button
        class="view-more-btn"
        type="button"
        data-testid="allo-history-view-more"
        (click)="showMore()">
        View more
      </button>
    }
  }
</div>

<!-- One row template for both sections, so the two lists cannot drift. -->
<ng-template #historyRow let-item>
  <div
    class="history-item"
    [class.history-item--active]="selectedChatId() === item.id"
    [class.history-item--editing]="editingChatId() === item.id"
    [class.history-item--pinned]="isPinned(item)"
    [attr.data-chat-id]="item.id"
    data-testid="allo-history-item">
    @if (editingChatId() === item.id) {
      <input
        class="history-item-title-input"
        type="text"
        data-testid="allo-history-rename-input"
        [value]="editingTitle()"
        (input)="onEditingTitleInput($event)"
        (blur)="saveEditTitle()"
        (keydown.enter)="saveEditTitle(); $event.preventDefault()"
        (keydown.escape)="cancelEditTitle(); $event.preventDefault()"
        (click)="$event.stopPropagation()" />
    } @else {
      <div class="history-item__row" (click)="select(item.id)">
        <span class="history-item-title" data-testid="allo-history-title">
          {{ item.title || ('GNR_AI_CHAT' | translate) }}
        </span>
        <div class="history-item__actions">
          <button
            class="history-item-action"
            type="button"
            data-testid="allo-history-pin-toggle"
            [attr.aria-label]="
              (isPinned(item) ? 'GNR_UNPIN_CHAT' : 'GNR_PIN_CHAT') | translate
            "
            [matTooltip]="
              (isPinned(item) ? 'GNR_UNPIN_CHAT' : 'GNR_PIN_CHAT') | translate
            "
            matTooltipPosition="below"
            (click)="togglePin(item); $event.stopPropagation()">
            <mat-icon>{{ isPinned(item) ? 'keep_off' : 'keep' }}</mat-icon>
          </button>
          <button
            class="history-item-action"
            type="button"
            data-testid="allo-history-more"
            [matMenuTriggerFor]="historyItemMenu"
            [matMenuTriggerData]="{ item: item }"
            [attr.aria-label]="'GNR_HISTORY' | translate"
            (click)="$event.stopPropagation()">
            <mat-icon>more_horiz</mat-icon>
          </button>
        </div>
      </div>
      <span class="history-item-preview">
        {{
          item.preview ||
            (item.updatedAt ? (item.updatedAt | date: 'medium') : '')
        }}
      </span>
    }
  </div>
</ng-template>

<mat-menu #historyItemMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button
      mat-menu-item
      type="button"
      data-testid="allo-history-menu-rename"
      (click)="startEditTitle(item)">
      <mat-icon>edit</mat-icon>
      <span>{{ 'GNR_RENAME' | translate }}</span>
    </button>
    <button
      mat-menu-item
      type="button"
      data-testid="allo-history-menu-pin"
      (click)="togglePin(item)">
      <mat-icon>{{ isPinned(item) ? 'keep_off' : 'keep' }}</mat-icon>
      <span>{{
        (isPinned(item) ? 'GNR_UNPIN_CHAT' : 'GNR_PIN_CHAT') | translate
      }}</span>
    </button>
    <mat-divider />
    <button
      mat-menu-item
      type="button"
      class="history-menu-item--danger"
      data-testid="allo-history-menu-delete"
      (click)="confirmDelete(item)">
      <mat-icon>delete</mat-icon>
      <span>{{ 'CMD_DELETE' | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
